<template>
  <div class="top" :style="{ position: isfixed ? 'fixed' : '', borderBottom: isfixed ? '' : '1px solid #DEDEDE' }">
    <div class="top_cont">
      <div class="top_l" @click="goindex">
        <!-- <img src="@/assets/top1.png" alt=""> -->
        <img src="@/assets/lo.png" alt="">
      </div>

      <div style="display:flex;align-items: center;">
        <div style="display:flex;">
          <div class="texts" @click="goindex">
            首页
          </div>
          <!-- <div class="texts" @click="goyjbj">
            一键比价
          </div> -->
        </div>

        <el-dropdown>
          <div class="top_user">
            <img style="cursor: pointer;" :src="userinfo.avatar" alt="" srcset="" @click="gouser()">
            <div class="uname">
              {{ userinfo.nickname }}
            </div>
            <i class="el-icon-arrow-down"></i>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="gouser()">我的主页</el-dropdown-item>
            <el-dropdown-item @click.native="outLogin()">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
import { removeToken } from '@/utils/auth'
import { mapState } from 'vuex'
export default {
  props: {
    isfixed: {
      default: true,
    }
  },
  name: '',
  data() {
    return {
      audioEle: null
    }
  },
  watch: {
 
  },
  computed: {
    ...mapState(['userinfo', 'nowIndex', 'xiaonum', 'isplay'])
  },
  mounted() {


  },
  methods: {
    delCookie() {
      localStorage.removeItem('hyinfo')
      localStorage.removeItem('userinfo')
      var cookies = document.cookie.split(";");
      for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i];
        var eqPos = cookie.indexOf("=");
        var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        document.cookie =
          name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
      }
      if (cookies.length > 0) {
        for (var i = 0; i < cookies.length; i++) {
          var cookie = cookies[i];
          var eqPos = cookie.indexOf("=");
          var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
          var domain = location.host.substr(location.host.indexOf("."));
          document.cookie =
            name +
            "=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=" +
            domain;
        }
      }
    },
    goyjbj() {
      this.$router.push({ path: "/yjbj" }).catch(() => { });

    },
    goindex() {
      this.$router.push({ path: "/" }).catch(() => { });
    },
    gouser() {
      this.$store.commit('SetNowIndex', 0)
      this.$router.push({ path: "/user" }).catch(() => { });
    },
    outLogin() {
      this.tim.logout()
      this.delCookie()
      this.$store.commit('SetNowIndex', 0)
      this.$router.push({ path: "/login" }).catch(() => { });
    }
  },
}
</script>
<style lang='scss' scoped>
.texts {
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 16px;
  color: #000000;
  margin-right: 30px;
  cursor: pointer;
}

.top {
  width: 100%;
  height: 80px;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 0px 0px 0px 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  z-index: 9;

  .top_cont {
    width: 1200px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .top_l {
      cursor: pointer;
      width: 219px;
      height: 46px;
      img {
        width: 219px;
        height: 46px;
      }
    }

    .top_user {
      display: flex;
      align-items: center;

      img {
        width: 30px;
        height: 30px;
        border-radius: 15px;
      }

      .uname {
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 16px;
        color: #000000;
        margin: 0 10px;
      }
    }
  }
}
</style>